<script setup>
import multiselect from "vue-multiselect";
import DatePicker from "vue2-datepicker";
import {ref, reactive, watch} from "vue";
import trackersPublicService from "@/services/trackers-public.service";
import {useStore} from "vue2-helpers/vuex";
import {encodeDateForServer} from "@/helpers/date";
import {getLogo} from "@/helpers/logo";

const store = useStore();

const trackers = ref(null);
const selectedCategories = ref([]);
const period = ref([null, null]);

const filter = reactive({
    categories: [],
    period: [null, null],
});

watch(selectedCategories, () => {
    filter.categories = selectedCategories.value.map(category => category.id);
});

watch(period, () => {
    filter.period = [
        encodeDateForServer(period.value[0]),
        encodeDateForServer(period.value[1])
    ];
});

watch(filter, () => {
    getList();
}, {deep: true, immediate: true})

async function getList() {
    const {data} = await trackersPublicService.getTrackersForApply({filter});
    trackers.value = data;
}
</script>

<template>
    <div class="main-inner">
        <div class="categories-section">
            <label class="categories-section__label">Categories:</label>
            <multiselect
                v-model="selectedCategories"
                :multiple="true"
                :options="store.state.categories"
                select-label=""
                deselect-label=""
                label="name"
                track-by="name"
                class="multiselect-mid"
            >
            </multiselect>

            <date-picker v-model="period" range></date-picker>
        </div>

        <template v-if="trackers !== null">
            <p v-if="!trackers.length">
                No public challenges match your filters.
            </p>

            <div v-for="tracker in trackers" :key="tracker.id" class="card card--bordered card--row">
                <div class="image-block image-block--lg">
                    <!-- Anonymous tracker for Rio Tinto -->
                    <img v-if="tracker.id !== 4207" :src="getLogo(tracker.company_logo)" alt="img">
                    <img v-else :src="getLogo()" alt="img">
                </div>

                <div class="card--row__content">
                    <h4 class="heading4 heading4--secondary">{{tracker.name}}</h4>

                    <p v-html="tracker.description" class="line-clamp line-clamp3"></p>
                </div>

                <router-link v-if="tracker.applied" :to="'/public-trackers/' + tracker.id" class="btn btn-bordered">View Submission</router-link>

                <router-link v-else :to="'/public-trackers/' + tracker.id" class="btn btn-primary btn-lg">Apply To Challenge</router-link>
            </div>
        </template>
    </div>
</template>

<style scoped>

</style>
